import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Teammate from './item';
import User from 'app/scripts/models/user';
import { Virtuoso } from 'react-virtuoso';
import { scroll } from 'utils/global';

class UsersList extends Component {
  static propTypes = {
    users: PropTypes.array.isRequired,
    className: PropTypes.string,
    onItemSelected: PropTypes.func,
    omReset: PropTypes.func,
    type: PropTypes.string,
    currentUserId: PropTypes.string,
    eventId: PropTypes.string,
    spot: PropTypes.object,
    addUser: PropTypes.func,
    removeUser: PropTypes.func,
    isViewOnlyMode: PropTypes.bool,
    userControls: PropTypes.object
  };

  static defaultProps = {
    users: [],
    onScroll: () => {}
  };

  static displayName = 'UsersList';

  render() {
    let {
      users,
      type,
      spot = {},
      currentUserId,
      eventId,
      onScroll,
      removeTopicAdmin,
      addUser,
      removeUser,
      isViewOnlyMode,
      userControls
    } = this.props;
    let className = 'teammates-users';
    if (this.props.className) {
      className += ` ${this.props.className}`;
    }

    return (
      <div className={className} onScroll={onScroll}>
        <Virtuoso
          style={{ height: 270, overflowY: 'scroll' }}
          data={users}
          overscan={20}
          itemContent={(index, user) => (
            <Teammate
              removeTopicAdmin={removeTopicAdmin}
              eventId={eventId}
              type={type}
              key={user.id || user.userId}
              currentUserId={currentUserId}
              user={user}
              spot={spot}
              lastElement={index === users.length - 1}
              addUser={addUser}
              removeUser={removeUser}
              isViewOnlyMode={isViewOnlyMode}
              userControls={userControls}
            />
          )}
        />
      </div>
    );
  }
}

export default UsersList;
